<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Customer Distribution
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm"
            >Delete</b-button
          >
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-form-group label-cols="3" label="Customer Code">
            <b-input-group>
              <b-form-input
                v-model="tblData.code"
                placeholder="Customer Code"
              ></b-form-input>
              <b-input-group-append>
                <span class="pl-2 pt-2 pr-1">
                  Group
                </span></b-input-group-append
              >
              <b-form-select
                v-model="tblData.customer_group"
                :plain="true"
                :options="customerGroups"
              ></b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group label-cols="3" label="Customer Name">
            <b-input-group>
              <b-form-input v-model="tblData.name"></b-form-input>
              <b-button class="btn btn-success ml-3 mr-1" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply Filter</b-button
              >
              <b-button class="btn btn-secondary mr-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear Filter</b-button
              >
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="selectItem"
      >
        <template v-slot:cell(Address)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="data.item.PhoneNo">P.{{ data.item.PhoneNo }}</span
          >&nbsp;
          <span v-if="data.item.FaxNo">F.{{ data.item.FaxNo }}</span>
        </template>
        <template v-slot:cell(CreditLimit)="data">
          {{ data.item.CreditLimit | numFormat }}
        </template>

        <template v-slot:cell(sundaydistribution)="data">
          <span :class="data.item.sundaydistribution == 'YES' ? 'alert-success navbar-link p-1' : 'alert-danger navbar-link p-1'">
            <span>{{ data.item.sundaydistribution }}</span>
          </span> 
        </template>
        <template v-slot:cell(mondaydistribution)="data">
          <span :class="data.item.mondaydistribution == 'YES' ? 'alert-success navbar-link p-1' : 'alert-danger navbar-link p-1'">
            <span>{{ data.item.mondaydistribution }}</span>
          </span> 
        </template>
        <template v-slot:cell(tuesdaydistribution)="data">
          <span :class="data.item.tuesdaydistribution == 'YES' ? 'alert-success navbar-link p-1' : 'alert-danger navbar-link p-1'">
            <span>{{ data.item.tuesdaydistribution }}</span>
          </span> 
        </template>
        <template v-slot:cell(wednesdaydistribution)="data">
          <span :class="data.item.wednesdaydistribution == 'YES' ? 'alert-success navbar-link p-1' : 'alert-danger navbar-link p-1'">
            <span>{{ data.item.wednesdaydistribution }}</span>
          </span> 
        </template>
        <template v-slot:cell(thursdaydistribution)="data">
          <span :class="data.item.thursdaydistribution == 'YES' ? 'alert-success navbar-link p-1' : 'alert-danger navbar-link p-1'">
            <span>{{ data.item.thursdaydistribution }}</span>
          </span> 
        </template>
        <template v-slot:cell(fridaydistribution)="data">
          <span :class="data.item.fridaydistribution == 'YES' ? 'alert-success navbar-link p-1' : 'alert-danger navbar-link p-1'">
            <span>{{ data.item.fridaydistribution }}</span>
          </span> 
        </template>
        <template v-slot:cell(saturdaydistribution)="data">
          <span :class="data.item.saturdaydistribution == 'YES' ? 'alert-success navbar-link p-1' : 'alert-danger navbar-link p-1'">
            <span>{{ data.item.saturdaydistribution }}</span>
          </span> 
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="[10, 20, 30, 50, 70, 90, 120]"
              :plain="true"
              v-model="tblData.limit"
              style="width: 80px"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showFrm" header-bg-variant="primary" size="lg" title="Form - Customer Distribution" :centered="true" @ok="save" ok-title="Save">
        <b-row >
          <b-col>
            <b-input-group >
              <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.customer" placeholder="Customer Name" :state="!$v.frmdata.customer_id.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuCustomerShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
            <div style="padding-top:20px;">Customer Distribution Days:</div>
            <b-row no-gutters>
              <b-col md="12">
                  <b-input-group >
                    <b-form-group
                      label-cols-sm="1"
                      label-size="sm"
                      description=""
                      class="mb-2 ml-2">
                        <b-form-checkbox v-model="frmdata.sunday" :value=1 :unchecked-value=0 class="pt-2">Sunday</b-form-checkbox>
                        <b-form-checkbox v-model="frmdata.monday" :value=1 :unchecked-value=0 class="pt-2">Monday</b-form-checkbox>
                        <b-form-checkbox v-model="frmdata.tuesday" :value=1 :unchecked-value=0 class="pt-2">Tuesday</b-form-checkbox>
                        <b-form-checkbox v-model="frmdata.wednesday" :value=1 :unchecked-value=0 class="pt-2">Wednesday</b-form-checkbox>
                        <b-form-checkbox v-model="frmdata.thursday" :value=1 :unchecked-value=0 class="pt-2">Thursday</b-form-checkbox>
                        <b-form-checkbox v-model="frmdata.friday" :value=1 :unchecked-value=0 class="pt-2">Friday</b-form-checkbox>
                        <b-form-checkbox v-model="frmdata.saturday" :value=1 :unchecked-value=0 class="pt-2">Saturday</b-form-checkbox>
                    </b-form-group>
                  </b-input-group>
              </b-col>
            </b-row>
          </b-col>
      </b-row>
    </b-modal>

    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
        <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal> 

      <b-modal
        v-model="showDelConfirm"
        title="Delete Record?"
        :centered="true"
        @ok="deleteData"
      >
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">
          Warning: You can't undo this action.
        </p>
      </b-modal>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>


<script>
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import customer from "../../apis/bakerycustomer";
import lkuCustomer from "../lookup/lkuCustomer";
import toastr from "mini-toastr";
toastr.init();

export default {
  components :{Loading,lkuCustomer},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        customer_id: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showFilter: false,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      terpilih: { customer_id: "" },
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        customer_group: "",
      },
      items:[],
      model:{},showFrm:false,
      frmdata: {customer_id:'', sunday:0, monday:0, tuesday: 0, wednesday:0, thursday:0, friday:0, saturday:0},
      lkuCustomerShow:false,
      customerGroups: [
        { value: "", text: "--ALL--" },
        { value: "RETAIL", text: "RETAIL" },
        { value: "WHOLESHALE", text: "WHOLESHALE" },
      ],
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    tblFields() {
      const fields = [
        {
          key: "CustCode",
          thStyle: "width:50px",
          label: "Code",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Customer Name",
          sortable: true,
        },
        {
          key: "customer_group",
          label: "Customer Group",
          sortable: true,
        },
        {
          key: "Bill2CustName",
          label: "Group/Holding",
          sortable: true,
        },
        {
          key: "sundaydistribution",
          thStyle: "width:50px",
          label: "Sunday",
          sortable: true,
        },
        {
          key: "mondaydistribution",
          thStyle: "width:50px",
          label: "Monday",
          sortable: true,
        },
        {
          key: "tuesdaydistribution",
          thStyle: "width:50px",
          label: "Tuesday",
          sortable: true,
        },
        {
          key: "wednesdaydistribution",
          thStyle: "width:50px",
          label: "Wednesday",
          sortable: true,
        },
        {
          key: "thursdaydistribution",
          thStyle: "width:50px",
          label: "Thursday",
          sortable: true,
        },
        {
          key: "fridaydistribution",
          thStyle: "width:50px",
          label: "Friday",
          sortable: true,
        },
        {
          key: "saturdaydistribution",
          thStyle: "width:50px",
          label: "Saturday",
          sortable: true,
        },
      ];
      return fields;
    },
  },
  created: async function () {
    const groups = await customer.group();
    this.customerGroups = groups.reduce(
      (newArr, item) => {
        newArr.push(item);
        return newArr;
      },
      [{ value: "", text: "---ALL---" }]
    );
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      const list = await customer.distributionlist(this.tblData);
      this.items=list;
      this.lkuLoading = false;
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.name = "";
      this.tblData.code = "";
      this.tblData.customer_group = "";
      this.refresh();
    },
    add: function(data) {
          this.frmdata.lockid= '';
          this.frmdata.customer_id= '';
          this.frmdata.CustCode= '';
          this.frmdata.CustName= '';
          this.frmdata.customer= '';
          this.frmdata.sunday= 0;
          this.frmdata.monday= 0;
          this.frmdata.tuesday= 0;
          this.frmdata.wednesday= 0;
          this.frmdata.thursday= 0;
          this.frmdata.friday= 0;
          this.frmdata.saturday= 0;
          this.showFrm=true;
    },

    edit: function() {
      //console.log("#this.model: ", this.model);
        if (this.model.lockid) {
          this.frmdata.lockid= this.model.lockid;
          this.frmdata.customer_id= this.model.customer_id;
          this.frmdata.CustCode= this.model.CustCode;
          this.frmdata.CustName= this.model.CustName;
          this.frmdata.customer= `${this.model.CustName} | ${this.model.CustCode}`;
          this.frmdata.sunday= this.model.sunday;
          this.frmdata.monday= this.model.monday;
          this.frmdata.tuesday= this.model.tuesday;
          this.frmdata.wednesday= this.model.wednesday;
          this.frmdata.thursday= this.model.thursday;
          this.frmdata.friday= this.model.friday;
          this.frmdata.saturday= this.model.saturday;
          this.showFrm=true;
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },

    onSelectLkuCustomer: async function (_selected) {
        // untuk filter
        this.tblData.customer = _selected.CustName.trim();
        this.tblData.customer_id = _selected.customer_id;
        this.tblData.CustCode = _selected.CustCode;
        this.tblData.CustName = _selected.CustName;

        // untuk set data form
        this.frmdata.customer_id = _selected.customer_id;
        this.frmdata.CustCode = _selected.CustCode;
        this.frmdata.CustName = _selected.CustName;
        this.frmdata.customer = `${_selected.CustName} | ${_selected.CustCode}`;
        //this.frmdata.Bill2CustNo = _selected.Bill2CustNo;
        this.lkuCustomerShow=false;
    }, 

    save: async function(evt) {
      evt.preventDefault()
      if (this.invalidFrmdata) {
          console.log('validation : ', this.$v.frmdata);
          console.log('frmdata obj : ',this.frmdata);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        try {
          this.showFrm = false;
          //console.log("#this.frmdata: ", this.frmdata);
          await customer.saveDistribution(this.frmdata);
          this.refresh();          
        } catch (error) {
          this.showFrm = true;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }            
        }
      }
  },

    // edit: function () {
    //   if (this.terpilih.customer_id) {
    //     router.push({
    //       name: "bakery.customerfrm",
    //       params: { customer_id: this.terpilih.customer_id },
    //     });
    //   } else {
    //     toastr.warn("Please select a row that want to be Edit!");
    //   }
    // },

    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        //console.log("#this.model: ", this.model);
        await customer.removeDistribution(this.model);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
          this.isLoading=false;            
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
      }
    },
    rowClicked(record, index) {
      if (this.terpilih.customer_id == record.customer_id) {
        console.log("terpilih row click: ", this.terpilih);
        this.edit();
      } else {
        if (this.terpilih && this.terpilih._rowVariant) {
          delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      }
    },
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },

    exportxls: async function () {
      this.isLoading = true;
      try {
        const response = await customer.exportxlsDistribution(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>
